/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_7_HInputs */

const en_terms_7_h = /** @type {(inputs: Terms_7_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability and liability`)
};

const id_terms_7_h = /** @type {(inputs: Terms_7_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketersediaan dan tanggung jawab`)
};

/**
* | output |
* | --- |
* | "Availability and liability" |
*
* @param {Terms_7_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_7_h = /** @type {((inputs?: Terms_7_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_7_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_7_h(inputs)
	return en_terms_7_h(inputs)
});